import { trackEvent } from '../../utils/analytics';
import { V2Destination } from '../../utils/v2Routes';

interface Props {
  destination: V2Destination;
  source: 'v2_strip' | 'v2_drawer';
}

export default function OpenInV2Link({ destination, source }: Props) {
  return (
    <a
      href={destination.url}
      onClick={() =>
        trackEvent('v2_app_launched', {
          source,
          fromRoute: destination.matchedPattern,
          toRoute: destination.url,
        })
      }
      className="inline-flex h-8 flex-shrink-0 items-center whitespace-nowrap rounded-md bg-[#4F46E5] px-[14px] text-sm font-medium text-white no-underline hover:bg-[#4338CA] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
    >
      Open in V2
    </a>
  );
}
